import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FlexStack } from '~/components/atomic';
import { SetAICharacterCard } from '~/components/atomic/Skeleton';
import { makeIndexArray } from '~/utils';

export default function SetAICharacterSkeleton() {
  return (
    <Container>
      <FlexStack>
        {makeIndexArray(2).map((e) => (
          <SetAICharacterCard key={e} />
        ))}
      </FlexStack>
      <FlexStack>
        {makeIndexArray(6).map((e) => (
          <SetAICharacterCard key={e} />
        ))}
      </FlexStack>
    </Container>
  );
}

const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 40px;
    padding: 0 16px;
    padding-top: calc(${theme.layout.chat_header_height} + 40px);
  `}
`;
